function PageIndicator({page}) {
    return (
        <div className='page-indicator'>
            <h3>{page}</h3>
        </div>
      
    )
}

export default PageIndicator;